module.exports = __webpack_public_path__ + "img/ma.24fb2561.jpg";